import { render, staticRenderFns } from "./AddHouseKeepMenu.vue?vue&type=template&id=12e2735c"
import script from "./AddHouseKeepMenu.vue?vue&type=script&lang=js"
export * from "./AddHouseKeepMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports